import React,{useEffect} from 'react';
import MaterialTable from 'material-table';
//import ExportData from './ExportData';
import { connect } from "react-redux";
import {editTask} from '../redux/actions/dataAction'
import {deleteTask} from '../redux/actions/dataAction'
import CustomButton from '../constants/CustomButton'
import CustomDialog from '../constants/CustomDialog'

function CustomTableWithAll(props) {
  const [state, setState] = React.useState({
    columns:undefined,
    data:undefined
  }); 
  const [openDialog, setOpenDialog] = React.useState({open:false}); 

useEffect(() => {
    setState({data:props.data})
}, [props.data],[state.data])
  const handleDialog = ()=>{
    setOpenDialog({open:true})
  }
  const handleClose = ()=>{
    setOpenDialog({open:false})
  }
  return (
    <>
    <CustomDialog open={openDialog.open} onClose={handleClose} identify={props.identify}></CustomDialog>
    {props.buttonRequired?<CustomButton onClick={handleDialog} label={props.buttonLabel}/>:""}
    <MaterialTable
      title={props.title}
      
      columns={props.columns}
      data={state.data}
      editable={{
       
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              if (oldData) {
                setState((prevState) => {
                  const data = [...prevState.data];
                  data[data.indexOf(oldData)] = newData;
                  console.log(newData,props.api)
                  props.editTask(props.api,newData);
                  return { ...prevState, data };
                });
              }
            }, 600);
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              setState((prevState) => {
                const data = [...prevState.data];
                data.splice(data.indexOf(oldData), 1);
                props.deleteTask(props.api,oldData);
                return { ...prevState, data };
              });
            }, 600);
          }),
      }}
    />
    </>
  );

}

const mapDispatchToProps = (dispatch) => {
  return {
    editTask: (task,data) => dispatch(editTask(task,data)),
    deleteTask: (order,data) => dispatch(deleteTask(order,data)),
  };
};
export default connect(null,mapDispatchToProps)(CustomTableWithAll)
